<template>
    <div v-if="!docTaskApprovalMode">
        <!-- <p class="text-right text-small">
            <a href @click.prevent="expandAll()">Expand all</a>
            <span class="text-muted px-1">|</span>
            <a href @click.prevent="collapseAll()">Collapse all</a>
        </p> -->

        <button-row v-if="client.has_company_docs_module && ($permissions.hasRolesInCompany(client.id, employee.company_id, $store.state.security_roles.HR_DOCUMENTS_ROLES) || $store.state.activeTour == 'hr-suite')" stacked class="pt-1 mb-2 pr-4 pl-4">
            <button class="btn btn-outline-primary" type="button" @click.prevent.stop="openAddDocumentModal" id="addDocButton">
                <i class="far fa-plus" aria-hidden="true" title="Add Document to Employee"></i>
                Add Document to Employee
            </button>
        </button-row>

        <!-- Completed HR Documents Widget -->
        <info-widget :collapsible="true" :is-expanded="completedDocsWidgetExpanded" @toggle_expand="completedDocsWidgetExpanded = !completedDocsWidgetExpanded" id="completedDocuments">
            <template v-slot:title>Completed Documents</template>

            <template v-slot:headerbutton v-if="!client.has_company_docs_module && $permissions.hasRolesInCompany(client.id, employee.company_id, $store.state.security_roles.HR_DOCUMENTS_ROLES)">
                <button class="btn btn-outline-primary" type="button" @click.prevent.stop="openDocumentUploadModal">
                    <i class="far fa-plus" aria-hidden="true" title="Upload"></i>
                    Upload
                </button>
            </template>

            <slot v-if="!$permissions.hasRolesInCompany(client.id, employee.company_id, $store.state.security_roles.HR_DOCUMENTS_ROLES) && !($store.state.activeTour == 'hr-suite')">
                <div class="info-widget-empty p-2">
                    This information is not available to your security role.
                </div>
            </slot>

            <slot v-if="$permissions.hasRolesInCompany(client.id, employee.company_id, $store.state.security_roles.HR_DOCUMENTS_ROLES) || $store.state.activeTour == 'hr-suite'">
                <div v-if="employeeDocsTableData.length" class="p-0">
                    <section class="table-section" v-for="docSection in completedDocSections" :key="docSection.slug">
                        <a href class="table-section-titlebar collapse-trigger" role="button" :class="{'is-expanded': expandedCompletedDocSections[docSection.slug]}" @click.prevent="expandedCompletedDocSections[docSection.slug] = !expandedCompletedDocSections[docSection.slug]">

                            <span class="widget-toggle-wrapper">
                                <collapse-toggle-button />
                            </span>
                            <h5 class="table-section-title">{{ docSection.title }} <span class="text-regular">({{ docSection.count }})</span></h5>
                        </a>
                        <table class="table css-table widget-table table-fixed" v-if="docSection.rows.length" v-show="expandedCompletedDocSections[docSection.slug]">
                            <thead>
                                <tr>
                                    <th class="cw-toggle"></th>
                                    <th>Document</th>
                                    <th class="cw-date text-right">Completed</th>
                                </tr>
                            </thead>
                            <tbody v-for="doc in docSection.rows" :key="doc.id" :class="{'active-item': doc.id == `employee-doc-${activeCompletedDocId}`}" ref="docs">
                                <tr>
                                    <td class="cw-toggle position-relative">
                                        <a href class="widget-toggle-wrapper collapse-trigger" role="button" :class="{'is-expanded': expandedCompletedDocs[doc.id]}" @click.prevent="expandedCompletedDocs[doc.id] = !expandedCompletedDocs[doc.id]">
                                            <collapse-toggle-button />
                                        </a>
                                    </td>
                                    <td class="d-flex">
                                        <span class="truncate-wrapper">
                                            <!-- Restrict PDF view if this is a a sensitive document (i.e. tax form) -->
                                            <a v-if="doc.is_restricted" href @click.prevent="setCurrentRestrictedDoc(doc)" class="truncate-content">
                                                {{ doc.name }}
                                            </a>
                                            <!-- Otherwise don't restrict PDF view -->
                                            <a v-else href @click.prevent="setCurrentPDF(doc)" class="truncate-content">
                                                {{ doc.name }}
                                            </a>
                                        </span>
                                        <i v-if="!doc.visible_to_employee" class="fas pl-hf pt-qt fa-eye-slash text-muted"></i>
                                    </td>
                                    <td class="cw-date text-right">
                                        <span>
                                            {{ $filters.dateshort(doc.completed_on || doc.date_added || doc.manager_date_signed) }}
                                        </span>
                                    </td>
                                </tr>
                                <tr class="child no-transition" v-show="expandedCompletedDocs[doc.id]">
                                    <td colspan="3">
                                        <div class="card card-body item-details" v-if="doc.source_pretty == 'Import'">
                                            <div>
                                                Imported document
                                            </div>
                                        </div>
                                        <div class="card card-body item-details" v-else>
                                            <div>
                                                <section class="item-details-section">
                                                    <div class="float-right">
                                                        <span class="text-danger-dark text-bold text-italic" v-if="!doc.most_recent">
                                                            Inactive
                                                        </span>
                                                        <span class="text-muted text-semibold" v-else>
                                                            Active
                                                        </span>
                                                    </div>
                                                    <p class="mb-hf">
                                                        Version: {{ doc.version }}
                                                    </p>
                                                    <p v-if="!(doc.document_type == 'uniform')">
                                                        File:
                                                        <!-- Restrict PDF view if this is a a sensitive document (i.e. tax form) -->
                                                        <a v-if="doc.is_restricted" href @click.prevent="setCurrentRestrictedDoc(doc)">{{ doc.filename }}</a>
                                                        <!-- Otherwise don't restrict PDF view -->
                                                        <a v-else href @click.prevent="setCurrentPDF(doc)">{{ doc.filename }}</a>
                                                    </p>
                                                    <div v-if="doc.document_type == 'uniform'">
                                                        <p v-for="item in doc.response_data">
                                                            <strong>{{ item.name }}</strong> <br/>
                                                            <span>Size: {{ item.category }} {{ item.size }}</span> <br/>
                                                            <span v-if="item.color">Color: {{ item.color }}</span>
                                                        </p>
                                                    </div>
                                                    <div v-if="doc.document_type == 'hr-custom-form'">
                                                        <p v-for="r in doc.response_data">
                                                            <strong>{{ r.prompt }}</strong> <br/>
                                                            <span v-if="r.question_type == 'address'">
                                                                {{ r.response.address_1 }} {{ r.response.address_2 }}<br/>
                                                                {{ r.response.city }}, {{ r.response.state }} {{ r.response.postal_code }}
                                                            </span>
                                                            <span v-else-if="r.question_type == 'select-multiple'">
                                                                {{ r.response.join(', ') }}
                                                            </span>
                                                            <span v-else-if="r.question_type == 'date'">
                                                                {{ $filters.date(r.response) }}
                                                            </span>
                                                            <span v-else-if="r.question_type == 'upload'">
                                                                <button
                                                                    class="btn btn-reset btn-link d-flex justify-content-center align-items-center"
                                                                    @click.prevent="imageModalUrl = makeHRCustomFormPhotoUrl((doc.employee_hr_custom_form || doc.onboarding_application_hr_custom_form), r.response.photo_id); imageModalTitle = r.response.filename; imageModalOpen = true;"
                                                                >
                                                                    <div class="flex-grow-0 docphoto-thumb mr-1" :style="{ backgroundImage: `url(${makeHRCustomFormPhotoUrl((doc.employee_hr_custom_form || doc.onboarding_application_hr_custom_form), r.response.photo_id)})` }"></div>
                                                                    <div class="flex-grow-1">{{ r.response.filename }}</div>
                                                                </button>
                                                            </span>
                                                            <span v-else>{{ r.response }}</span>
                                                        </p>
                                                    </div>
                                                </section>
                                                <section class="item-details-section" v-if="doc.source_pretty == 'Onboarding' || doc.source_pretty == 'ESS'">
                                                    <p>
                                                        <span v-if="doc.manager_date_signed">
                                                            Submitted by Employee On: {{ $filters.date(doc.date_signed || doc.date_submitted) }}<br/>
                                                            Approved by Manager On: {{ $filters.date(doc.manager_date_signed) }}<br/>
                                                            <span v-if="doc.manager_name">Approved/Signed By: {{ doc.manager_name }}</span>
                                                        </span>
                                                        <span v-else>
                                                            Completed by Employee On: {{ $filters.date(doc.date_signed || doc.date_submitted) }}
                                                        </span>
                                                    </p>
                                                </section>
                                                <section class="item-details-section" v-else-if="doc.source_pretty == 'Manager'">
                                                    <p>
                                                        Completed by Manager On: {{ $filters.date(doc.date_added) }} <br/>
                                                        <span v-if="doc.manager_name">Completed By: {{ doc.manager_name }}</span>
                                                    </p>
                                                    <p v-if="!doc.visible_to_employee">
                                                        Visible to Employee: No
                                                    </p>
                                                    <p v-if="$permissions.hasRolesInCompany(client.id, employee.company_id, $store.state.security_roles.HR_DOCUMENTS_ROLES)">
                                                        <a href @click.prevent="docToRemove = doc">Remove Document</a>
                                                    </p>
                                                </section>
                                                <section class="item-details-section" v-else-if="doc.source_pretty == 'Upload'">
                                                    <p v-if="doc.completed_on">
                                                        Completed On: {{ $filters.date(doc.completed_on) }}
                                                    </p>
                                                    <p>
                                                        Uploaded On: {{ $filters.date(doc.date_added) }} <br/>
                                                        <span v-if="doc.manager_name">Uploaded By: {{ doc.manager_name }}</span>
                                                    </p>
                                                    <p v-if="!doc.visible_to_employee">
                                                        Visible to Employee: No
                                                    </p>
                                                    <p v-if="$permissions.hasRolesInCompany(client.id, employee.company_id, $store.state.security_roles.HR_DOCUMENTS_ROLES)">
                                                        <a href @click.prevent="docToRemove = doc">Remove Document</a>
                                                    </p>
                                                </section>
                                                <section class="item-details-section" v-else-if="doc.source_pretty == 'Import'">
                                                    <p>
                                                        Uploaded On: {{ $filters.date(doc.date_added) }} <br/>
                                                        <span v-if="doc.manager_name">Uploaded By: {{ doc.manager_name }}</span>
                                                    </p>
                                                    <p v-if="$permissions.hasRolesInCompany(client.id, employee.company_id, $store.state.security_roles.HR_DOCUMENTS_ROLES)">
                                                        <a href @click.prevent="docToRemove = doc">Remove Document</a>
                                                    </p>
                                                </section>
                                                <section class="item-details-section" v-if="employee.company.feature_i9_document_photos && doc.onboarding_application_pdf_form && doc.onboarding_application_pdf_form.form_designation == 'i9'">
                                                    <document-photos-list
                                                        :client="client"
                                                        :company="employee.company"
                                                        :onboarding-application-id="doc.onboarding_application_pdf_form.onboarding_application_id"
                                                        :form="doc.onboarding_application_pdf_form"
                                                        :most-recent-i9="doc.most_recent"
                                                        @updated="onUpdate"
                                                    />
                                                </section>
                                            </div>
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                        <div class="row-empty" v-if="!docSection.rows.length" v-show="expandedCompletedDocSections[docSection.slug]">
                            This section is empty.
                        </div>
                    </section>
                </div>

                <div v-else>
                    <div class="info-widget-empty p-2">
                        This employee has no completed HR documents.
                    </div>
                </div>
            </slot>
        </info-widget>

        <!-- Incomplete HR Documents Widget -->
        <info-widget v-if="hrDocsSuiteEnabled" :collapsible="true" :is-expanded="incompleteDocsWidgetExpanded" @toggle_expand="incompleteDocsWidgetExpanded = !incompleteDocsWidgetExpanded" id="incompleteDocuments">
            <template v-slot:title>Incomplete Documents</template>

            <slot v-if="!$permissions.hasRolesInCompany(client.id, employee.company_id, $store.state.security_roles.HR_DOCUMENTS_ROLES) && !($store.state.activeTour == 'hr-suite')">
                <div class="info-widget-empty p-2">
                    This information is not available to your security role.
                </div>
            </slot>

            <slot v-if="$permissions.hasRolesInCompany(client.id, employee.company_id, $store.state.security_roles.HR_DOCUMENTS_ROLES) || $store.state.activeTour == 'hr-suite'">
                <div v-if="incompleteDocTasksTableData.length" class="p-0">
                    <section class="table-section" v-for="docSection in incompleteDocSections" :key="docSection.slug">
                        <a href class="table-section-titlebar collapse-trigger" role="button" :class="{'is-expanded': expandedIncompleteDocSections[docSection.slug]}" @click.prevent="expandedIncompleteDocSections[docSection.slug] = !expandedIncompleteDocSections[docSection.slug]">

                            <span class="widget-toggle-wrapper">
                                <collapse-toggle-button />
                            </span>
                            <h5 class="table-section-title">{{ docSection.title }} <span class="text-regular">({{ docSection.count }})</span></h5>
                        </a>
                        <table class="table css-table widget-table table-fixed" v-if="docSection.rows.length" v-show="expandedIncompleteDocSections[docSection.slug]">
                            <thead>
                                <tr>
                                    <th class="cw-toggle"></th>
                                    <th>Document</th>
                                    <th class="cw-date text-right">{{ docSection.dateFieldTitle }}</th>
                                </tr>
                            </thead>
                            <tbody v-for="doc in docSection.rows" :key="doc.id" :class="{'active-item': doc.id == activeIncompleteDocTaskId}" ref="incompleteDocs">
                                <tr>
                                    <td class="cw-toggle position-relative">
                                        <a href class="widget-toggle-wrapper collapse-trigger" role="button" :class="{'is-expanded': expandedIncompleteDocTasks[doc.id]}" @click.prevent="expandedIncompleteDocTasks[doc.id] = !expandedIncompleteDocTasks[doc.id]">
                                            <collapse-toggle-button />
                                        </a>
                                    </td>
                                    <td class="truncate-wrapper">
                                        <a href v-if="doc.url" @click.prevent="setCurrentPDF(doc)" class="paycheck truncate-content">{{ doc.name }}</a>
                                        <span v-else class="paycheck truncate-content">{{ doc.name }}</span>
                                    </td>
                                    <td class="cw-date text-right">
                                        <span v-if="docSection.slug == 'pending-employee-completion'">
                                            {{ $filters.dateshort(doc.last_reminded_on) }}
                                        </span>
                                        <span v-if="docSection.slug == 'pending-manager-completion'">
                                            -
                                        </span>
                                        <span v-if="docSection.slug == 'needs-manager-approval'">
                                            {{ $filters.dateshort(doc.responded_on) }}
                                        </span>
                                    </td>
                                </tr>
                                <tr class="child no-transition" v-show="expandedIncompleteDocTasks[doc.id]">
                                    <td colspan="3">
                                        <div class="card card-body item-details">
                                            <div>
                                                <section class="item-details-section">
                                                    <template v-if="doc.status == 'needs-manager-approval'">
                                                        <p class="mb-hf" v-if="doc.submitted_version_number">
                                                            Version: {{ doc.submitted_version_number }}
                                                        </p>
                                                        <p v-if="doc.url">
                                                            File: <a href @click.prevent="setCurrentPDF(doc)">{{ doc.filename }}</a>
                                                        </p>
                                                        <div v-if="doc.employee_hr_custom_form">
                                                            <p v-for="r in doc.employee_hr_custom_form.response_data">
                                                                <strong>{{ r.prompt }}</strong> <br/>
                                                                <span v-if="r.question_type == 'address'">
                                                                    {{ r.response.address_1 }} {{ r.response.address_2 }}<br/>
                                                                    {{ r.response.city }}, {{ r.response.state }} {{ r.response.postal_code }}
                                                                </span>
                                                                <span v-else-if="r.question_type == 'select-multiple'">
                                                                    {{ r.response.join(', ') }}
                                                                </span>
                                                                <span v-else-if="r.question_type == 'date'">
                                                                    {{ $filters.date(r.response) }}
                                                                </span>
                                                                <span v-else-if="r.question_type == 'upload'">
                                                                    <button
                                                                        class="btn btn-reset btn-link d-flex justify-content-center align-items-center"
                                                                        @click.prevent="imageModalUrl = makeHRCustomFormPhotoUrl(doc.employee_hr_custom_form, r.response.photo_id); imageModalTitle = r.response.filename; imageModalOpen = true;"
                                                                    >
                                                                    <div class="flex-grow-0 docphoto-thumb mr-1" :style="{ backgroundImage: `url(${makeHRCustomFormPhotoUrl(doc.employee_hr_custom_form, r.response.photo_id)})` }"></div>
                                                                        <div class="flex-grow-1">{{ r.response.filename }}</div>
                                                                    </button>
                                                                </span>
                                                                <span v-else>{{ r.response }}</span>
                                                            </p>
                                                        </div>
                                                    </template>
                                                    <p class="mb-hf">Required On: {{ $filters.date(doc.assigned_on) }}</p>
                                                    <p v-if="doc.assigned_by">Required By: {{ doc.assigned_by }}</p>
                                                    <p v-if="doc.due_on">Due On: {{ doc.due_on }}</p>
                                                    <p v-if="doc.responded_on">Submitted by Employee On: {{ $filters.date(doc.responded_on) }}</p>
                                                    <template v-else>
                                                        <p v-if="doc.collection_method == 'employee' && doc.last_reminded_on != doc.assigned_on">Last Reminded On: {{ $filters.date(doc.last_reminded_on) }}</p>
                                                        <p>
                                                            Collection Settings:
                                                            <span v-if="doc.status == 'needs-employee-response'">Employee will complete, </span>
                                                            <span v-if="doc.status == 'needs-manager-response'">Manager will complete, </span>
                                                            <span v-if="doc.block_ee_until_completion">block access</span>
                                                            <span v-else>allow access</span>
                                                        </p>
                                                    </template>
                                                    <div v-if="!doc.responded_on && $permissions.hasRolesInCompany(client.id, employee.company_id, $store.state.security_roles.HR_DOCUMENTS_ROLES)">
                                                        <a href @click.prevent="openCancelDocTaskModal(doc)">Cancel Document</a>
                                                        <button-row  v-if="canEditCollectionSettings" stacked class="m-0">
                                                            <button class="btn btn-outline-primary m-0" @click.prevent="openCollectionSettingsModal(doc)">
                                                                <i class="far fa-cog" aria-hidden="true"></i> Edit Collection Settings
                                                            </button>
                                                        </button-row>
                                                        <button-row stacked class="m-0">
                                                            <button class="btn btn-primary m-0" @click.prevent="openCompleteDocTaskModal(doc)">
                                                                <i class="far fa-check" aria-hidden="true"></i> Complete Document
                                                            </button>
                                                        </button-row>
                                                    </div>
                                                </section>
                                            </div>
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                        <div v-if="docSection.rows.length">
                            <button-row v-if="expandedIncompleteDocSections[docSection.slug] && docSection.slug == 'needs-manager-approval'" stacked class="mt-1 mb-0">
                                <button class="btn btn-primary" @click.prevent="startDocTaskApproval()">
                                    Start Approval
                                </button>
                            </button-row>
                            <button-row v-if="expandedIncompleteDocSections[docSection.slug] && docSection.slug == 'pending-employee-completion'" stacked class="mt-1 mb-0">
                                <button class="btn btn-primary" @click.prevent="sendReminder">
                                    Send Reminder
                                </button>
                            </button-row>
                        </div>
                        <div class="row-empty" v-if="!docSection.rows.length" v-show="expandedIncompleteDocSections[docSection.slug]">
                            This section is empty.
                        </div>
                    </section>
                </div>

                <div v-else>
                    <div class="info-widget-empty p-2">
                        This employee has no incomplete HR documents.
                    </div>
                </div>
            </slot>
        </info-widget>

        <!-- Canceled HR Documents Widget -->
        <info-widget v-if="hrDocsSuiteEnabled" :collapsible="true" :is-expanded="canceledDocsWidgetExpanded" @toggle_expand="canceledDocsWidgetExpanded = !canceledDocsWidgetExpanded">
            <template v-slot:title>Canceled Documents</template>

            <slot v-if="!$permissions.hasRolesInCompany(client.id, employee.company_id, $store.state.security_roles.HR_DOCUMENTS_ROLES)">
                <div class="info-widget-empty p-2">
                    This information is not available to your security role.
                </div>
            </slot>

            <slot v-if="$permissions.hasRolesInCompany(client.id, employee.company_id, $store.state.security_roles.HR_DOCUMENTS_ROLES)">
                <div v-if="canceledDocTasksTableData.length" class="p-0">
                    <table class="table css-table widget-table table-fixed">
                        <thead>
                            <tr>
                                <th class="cw-toggle"></th>
                                <th>Document</th>
                                <th class="cw-date text-right">Canceled On</th>
                            </tr>
                        </thead>
                        <tbody v-for="doc in canceledDocTasksTableData" :key="doc.id" :class="{'active-item': doc.id == activeCanceledDocTaskId}" ref="docs">
                            <tr>
                                <td class="cw-toggle position-relative">
                                    <a href class="widget-toggle-wrapper collapse-trigger" role="button" :class="{'is-expanded': expandedCanceledDocTasks[doc.id]}" @click.prevent="expandedCanceledDocTasks[doc.id] = !expandedCanceledDocTasks[doc.id]">
                                        <collapse-toggle-button />
                                    </a>
                                </td>
                                <td class="truncate-wrapper">
                                    <a href v-if="doc.url" @click.prevent="setCurrentPDF(doc)" class="paycheck truncate-content">{{ doc.name }}</a>
                                    <span v-else class="paycheck truncate-content">{{ doc.name }}</span>
                                </td>
                                <td class="cw-date text-right">
                                    <span>
                                        {{ $filters.dateshort(doc.canceled_on) }}
                                    </span>
                                </td>
                            </tr>
                            <tr class="child no-transition" v-show="expandedCanceledDocTasks[doc.id]">
                                <td colspan="3">
                                    <div class="card card-body item-details">
                                        <div>
                                            <section class="item-details-section">
                                                <template v-if="doc.submitted_version_number">
                                                    <p class="mb-hf">
                                                        Version: {{ doc.submitted_version_number }}
                                                    </p>
                                                    <p v-if="doc.url">
                                                        File: <a href @click.prevent="setCurrentPDF(doc)">{{ doc.filename }}</a>
                                                    </p>
                                                </template>
                                            </section>
                                            <section class="item-details-section">
                                                <p class="mb-hf">Required On: {{ $filters.datetime(doc.assigned_on) }}</p>
                                                <p v-if="doc.assigned_by">Required By: {{ doc.assigned_by }}</p>
                                                <p class="mb-hf">Canceled On: {{ $filters.datetime(doc.canceled_on) }}</p>
                                                <p v-if="doc.canceled_by">Canceled By: {{ doc.canceled_by }}</p>
                                            </section>
                                        </div>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                <div v-else>
                    <div class="info-widget-empty p-2">
                        This employee has no canceled HR documents.
                    </div>
                </div>
            </slot>
        </info-widget>
    </div>

    <doc-task-approval
        v-if="docTaskApprovalMode"
        :doctasks="this.docTasksPendingApproval"
        :employee="employee"
        :client="client"
        @close="docTaskApprovalMode = false"
        @updated="onUpdate"
    />

    <pdf-modal :url="currentPDF.url" :title="currentPDF.title" v-if="currentPDF" @close="currentPDF = null" ref="pdfModal" />
    <document-upload-modal :client="client" :employee="employee" @updated="onUpdate" v-if="documentUploadModalOpen" @close="documentUploadModalOpen = false" />
    <add-employee-document-modal :client="client" :employee="employee" @updated="onUpdate" v-if="addDocumentModalOpen" @close="addDocumentModalOpen = false" />
    <complete-document-task-modal :client="client" :employee="employee" :doc-task="docTaskToComplete" @updated="onUpdate" v-if="docTaskToComplete" @close="docTaskToComplete = null" />
    <doc-task-collection-settings-modal v-if="collectionSettingsDocTask" @close="collectionSettingsDocTask = null" @updated="onUpdate" :docTask="collectionSettingsDocTask" :client="client" :employee="employee"/>
    <view-document-modal :client-id="client.id" :doc="currentRestrictedDoc" v-if="currentRestrictedDoc" @submit="openRestrictedDoc(currentRestrictedDoc)" @close="currentRestrictedDoc = false"/>
    <image-modal
        v-if="imageModalOpen"
        :imageUrl="imageModalUrl"
        :imageTitle="imageModalTitle"
        @close="imageModalOpen = false; imageModalUrl = ''; imageModalTitle = ''"
    />
    <confirm-modal v-if="docToRemove" title="Confirm: Remove Document" confirm-button-text="Remove" @submit.prevent="removeDocument()" @close="docToRemove = null">
        <template v-slot:subheading>
            <div class="p-1 unpad-x bg-150 rounded">
                <div><span class="text-muted">Employee:</span> {{ employee.full_name }}</div>
                <div><span class="text-muted">Document:</span> {{ docToRemove.name }}</div>
            </div>
        </template>
    </confirm-modal>

    <confirm-modal v-if="docTaskToCancel" title="Confirm: Cancel Document" confirm-button-text="Cancel Document" @submit.prevent="cancelDocTask()" @close="docTaskToCancel = null">
        <template v-slot:subheading>
            <div class="p-1 unpad-x bg-150 rounded">
                <div><span class="text-muted">Employee:</span> {{ employee.full_name }}</div>
                <div><span class="text-muted">Document:</span> {{ docTaskToCancel?.name }}</div>
            </div>
            <p class="mt-2 mb-0">
                Are you sure you want to cancel this document? This document will no longer be required for this employee. A warning will be generated.
            </p>
        </template>
    </confirm-modal>

</template>

<script>
import InfoWidget from '@/components/InfoWidget'
import ButtonRow from '@/components/ButtonRow'
import ImageModal from '@/components/ImageModal'
import PdfModal from '@/components/PdfModal'
import ConfirmModal from '@/components/ConfirmModal'

import DocumentPhotosList from '@/components/EmployeeSidebar/DocumentPhotosList'
import ViewDocumentModal from '@/components/EmployeeSidebar/ViewDocumentModal'

import DocTaskApproval from './DocTaskApproval'
import DocumentUploadModal from './DocumentUploadModal'
import AddEmployeeDocumentModal from './AddEmployeeDocumentModal'
import CompleteDocumentTaskModal from './CompleteDocumentTaskModal'
import DocTaskCollectionSettingsModal from './DocTaskCollectionSettingsModal'

export default {
    components: {
        InfoWidget, ButtonRow, ImageModal, PdfModal, ConfirmModal,
        DocumentPhotosList, ViewDocumentModal,
        DocTaskApproval, DocumentUploadModal, AddEmployeeDocumentModal, CompleteDocumentTaskModal, DocTaskCollectionSettingsModal
    },
    props: ['employee', 'client', 'employeeDocuments', 'employeeDocumentTasks', 'section', 'itemId', 'expandedItemsSubsection'],
    emits: ['updated', 'doc-task-canceled', 'employee-document-removed'],
    data() {
        const activeCompletedDocId = (this.section == 'completed-docs') ? this.itemId : null
        const activeIncompleteDocTaskId = (this.section == 'incomplete-docs' ? this.itemId : null)
        const activeCanceledDocTaskId = (this.section == 'canceled-docs' ? this.itemId : null)
        const expandedCompletedDocs = {}
        const expandedIncompleteDocTasks = {}
        const expandedCanceledDocTasks = {}
        let expandedCompletedDocSections = {
            'active': true,
            'inactive': false,
        }
        let expandedIncompleteDocSections = {
            'pending-employee-completion': true,
            'pending-manager-completion': true,
            'ready-for-approval': true,
        }
        let expandedCanceledDocSections = {
            'rejected': true,
            'requirement-removed': true,
        }
        if (activeCompletedDocId) {
            expandedCompletedDocs[`employee-doc-${activeCompletedDocId}`] = true
            if (this.expandedItemsSubsection == 'inactive') {
                expandedCompletedDocSections = {
                    'active': false,
                    'inactive': true,
                }
            }
        } else if (activeIncompleteDocTaskId) {
            expandedIncompleteDocTasks[activeIncompleteDocTaskId] = true
        } else if (activeCanceledDocTaskId) {
            expandedCanceledDocTasks[activeCanceledDocTaskId] = true
        }

        return {
            docTaskApprovalMode: false,
            currentPDF: null,
            currentRestrictedDoc: null,
            docToRemove: null,
            docTaskToCancel: null,
            collectionSettingsDocTask: null,
            expandedCompletedDocs: expandedCompletedDocs,
            expandedIncompleteDocTasks: expandedIncompleteDocTasks,
            expandedCanceledDocTasks: expandedCanceledDocTasks,
            expandedCompletedDocSections: expandedCompletedDocSections,
            expandedIncompleteDocSections: expandedIncompleteDocSections,
            expandedCanceledDocSections: expandedCanceledDocSections,
            documentUploadModalOpen: false,
            addDocumentModalOpen: false,
            docTaskToComplete: null,
            completedDocsWidgetExpanded: this.section == 'completed-docs' || !this.section,
            incompleteDocsWidgetExpanded: this.section == 'incomplete-docs',
            canceledDocsWidgetExpanded: this.section == 'canceled-docs',
            activeCompletedDocId: activeCompletedDocId,
            activeIncompleteDocTaskId: activeIncompleteDocTaskId,
            activeCanceledDocTaskId: activeCanceledDocTaskId,
            imageModalOpen: false,
            imageModalUrl: '',
            imageModalTitle: '',
        }
    },
    computed: {
        completedDocSections() {
            let activeDocs = this.employeeDocsTableData.filter((d) => {return d.most_recent})
            let inactiveDocs = this.employeeDocsTableData.filter((d) => {return !d.most_recent})
            let sections = [
                {
                    'slug': 'active',
                    'title': 'Active Documents',
                    'count': activeDocs.length,
                    'rows': activeDocs,
                },
                {
                    'slug': 'inactive',
                    'title': 'Inactive Documents',
                    'count': inactiveDocs.length,
                    'rows': inactiveDocs,
                }
            ]
            return sections
        },
        incompleteDocSections() {
            let docTasksPendingEmployeeCompletion = this.incompleteDocTasksTableData.filter((d) => {return d.status == 'needs-employee-response'})
            let docTasksPendingManagerCompletion = this.incompleteDocTasksTableData.filter((d) => {return d.status == 'needs-manager-response'})
            let docTasksPendingApproval = this.incompleteDocTasksTableData.filter((d) => {return d.status == 'needs-manager-approval'})
            return [
                {
                    'slug': 'needs-manager-approval',
                    'title': 'Ready for Approval',
                    'dateFieldTitle': 'Submitted On',
                    'count': docTasksPendingApproval.length,
                    'rows': docTasksPendingApproval,
                },
                {
                    'slug': 'pending-employee-completion',
                    'title': 'Pending Employee Completion',
                    'dateFieldTitle': 'Reminded On',
                    'count': docTasksPendingEmployeeCompletion.length,
                    'rows': docTasksPendingEmployeeCompletion,
                },
                {
                    'slug': 'pending-manager-completion',
                    'title': 'Pending Manager Completion',
                    'dateFieldTitle': 'Due On',
                    'count': docTasksPendingManagerCompletion.length,
                    'rows': docTasksPendingManagerCompletion,
                },
            ]
        },
        employeeDocsTableData() {
            const result = []

            if (this.employee) {
                this.employeeDocuments.forEach(d => {
                    let dateSigned = ''
                    if (d.signature_data) {
                        if (d.signature_data.signature) {
                            dateSigned = d.signature_data.signature.date ? d.signature_data.signature.date : ''
                        } else if (d.signature_data.date) {
                            dateSigned = d.signature_data.date
                        }
                    }
                    let managerDateSigned = ''
                    if (d.signature_data.manager_signature) {
                        managerDateSigned = d.signature_data.manager_signature.date
                    }

                    result.push({
                        id: `employee-doc-${d.id}`,
                        url: `${this.$api.API_BASE}/clients/${this.client.id}/employees/${this.employee.id}/documents/${d.id}/pdf`,
                        name: d.name,
                        filename: d.name.toLowerCase().endsWith('.pdf') ? d.name : d.name + '.pdf',
                        version: d.version,
                        date_signed: dateSigned,
                        manager_date_signed: managerDateSigned,
                        manager_name: d.signature_data.manager_signature ? d.signature_data.manager_signature.full_name : '',
                        date_submitted: d.date_submitted,
                        date_added: d.date_added,
                        completed_on: d.completed_on,
                        visible_to_employee: d.visible_to_employee,
                        source_pretty: d.source_pretty,
                        document_type: d.document_type,
                        employee_document: d,
                        onboarding_application_pdf_form: d.onboarding_application_pdf_form,
                        onboarding_application_hr_document: d.onboarding_application_hr_document,
                        onboarding_application_hr_form_document: d.onboarding_application_hr_form_document,
                        onboarding_application_uniform: d.onboarding_application_uniform,
                        onboarding_application_hr_custom_form: d.onboarding_application_hr_custom_form,
                        employee_update_pdf_form: d.employee_update_pdf_form,
                        employee_hr_document: d.employee_hr_document,
                        employee_uniform: d.employee_uniform,
                        employee_hr_custom_form: d.employee_hr_custom_form,
                        response_data: d.response_data,
                        most_recent: d.most_recent,
                        is_restricted: d.is_restricted,
                    })
                })
            }

            return result
        },
        docTasksTableData() {
            let result = []

            this.employeeDocumentTasks.forEach(t => {
                let url = ''
                if (t.employee_hr_document_id) {
                    url = `${this.$api.API_BASE}/clients/${this.client.id}/employees/${this.employee.id}/hr-documents/${t.employee_hr_document_id}/signed`
                } else if (t.hr_document) {
                    url = `${this.$api.API_BASE}/clients/${this.client.id}/hr-documents/${t.hr_document_id}/file/pdf`
                } else if (t.employee_hr_custom_form) {
                    url = `${this.$api.API_BASE}/clients/${this.client.id}/employees/${this.employee.id}/hr-custom-forms/${t.employee_hr_custom_form_id}/pdf`
                }
                result.push({
                    id: t.id,
                    url: url,
                    name: t.document_name,
                    task_type: t.task_type,
                    filename: t.document_name.toLowerCase().endsWith('.pdf') ? t.document_name : t.document_name + '.pdf',
                    hr_document: t.hr_document,
                    hr_custom_form: t.hr_custom_form,
                    employee_hr_custom_form: t.employee_hr_custom_form,
                    uniform: t.uniform,
                    submitted_version_number: t.submitted_version_number,
                    assigned_on: t.assigned_on,
                    assigned_by: t.assigned_by_pretty,
                    due_on: t.due_on,
                    last_reminded_on: t.last_reminded_on || t.assigned_on,
                    canceled_on: t.canceled_on,
                    canceled_by: t.canceled_by_pretty,
                    responded_on: t.responded_on,
                    block_ee_until_completion: t.block_ee_until_completion,
                    status: t.status,
                })
            })

            return result
        },
        incompleteDocTasksTableData() {
            return this.docTasksTableData.filter(t => ['needs-employee-response', 'needs-manager-response', 'needs-manager-approval'].includes(t.status))
        },
        canceledDocTasksTableData() {
            return this.docTasksTableData.filter(t => ['exempted', 'canceled'].includes(t.status))
        },
        docTasksPendingApproval() {
            return this.employeeDocumentTasks.filter(t => t.status == 'needs-manager-approval')
        },
        hrDocsSuiteEnabled() {
            if (!this.employee) { return false }
            return (this.client.has_company_docs_module && this.employee.company.has_company_docs_module) ||
                (this.client.has_uniform_module && this.employee.company.has_uniform_module) ||
                (this.client.has_custom_forms_module && this.employee.company.has_custom_forms_module) ||
                (this.client.has_ad_hoc_docs_module && this.employee.company.has_ad_hoc_docs_module)
        },
        canEditCollectionSettings() {
            return this.$permissions.hasRolesInCompany(this.client.id, this.employee.company_id, this.$store.state.security_roles.HR_DOCUMENTS_ROLES)
        }
    },
    methods: {
        startDocTaskApproval() {
            this.docTaskApprovalMode = true
        },
        sendReminder() {
            this.$store.dispatch('START_LOADING')
            this.$api.post(`/clients/${this.client.id}/employees/${this.employee.id}/document-tasks/send-reminder`, {}).then(() => {
                this.$store.dispatch('STOP_LOADING')
                this.$bus.showInfo(`Email sent to ${this.employee.email}.`)
                this.onUpdate()
            }).catch((errors) => {
                this.$store.dispatch('STOP_LOADING')
                this.$bus.showError(this.$bus.firstError(errors))
            })
        },
        setCurrentRestrictedDoc(doc) {
            this.currentRestrictedDoc = doc
        },
        openRestrictedDoc(doc) {
            this.currentRestrictedDoc = null
            this.currentPDF = {
                title: doc.name,
                url: {
                    url: doc.url,
                    withCredentials: true,
                },
            }
        },
        setCurrentPDF(doc) {
            this.currentRestrictedDoc = null
            this.currentPDF = {
                title: doc.name,
                url: {
                    url: doc.url,
                    withCredentials: true,
                },
            }
        },
        openCancelDocTaskModal(docTask) {
            this.docTaskToCancel = docTask
        },
        openCollectionSettingsModal(docTask) {
            this.collectionSettingsDocTask = docTask
        },
        cancelDocTask() {
            if (!this.docTaskToCancel) {return}

            this.$store.dispatch('START_LOADING')
            this.$api.post(`/clients/${this.client.id}/employees/${this.employee.id}/document-tasks/${this.docTaskToCancel.id}`, {'action': 'cancel'}).then(() => {
                this.$store.dispatch('STOP_LOADING')
                this.$bus.showInfo(`Document was successfully canceled.`)
                this.$emit('doc-task-canceled', this.docTaskToCancel.id)
                this.docTaskToCancel = null
                this.onUpdate()
            }).catch((errors) => {
                this.$store.dispatch('STOP_LOADING')
                this.$bus.showError(errors.__all__)
            })
        },
        removeDocument() {
            if (!this.docToRemove) {return}
            if (!this.docToRemove.employee_document) {return}

            this.$store.dispatch('START_LOADING')
            this.$api.del(`/clients/${this.client.id}/employees/${this.employee.id}/documents/${this.docToRemove.employee_document.id}?version=${this.docToRemove.employee_document.version}`).then(() => {
                this.$store.dispatch('STOP_LOADING')
                this.$bus.showInfo(`Document was successfully removed.`)
                this.$emit('employee-document-removed', this.docToRemove.employee_document.id)
                this.docToRemove = null
                this.onUpdate()
            }).catch((errors) => {
                this.$store.dispatch('STOP_LOADING')
                this.$bus.showError(errors.__all__)
            })
        },
        expandAll() {
            this.completedDocsWidgetExpanded = true
            this.incompleteDocsWidgetExpanded = true
            this.canceledDocsWidgetExpanded = true
        },
        collapseAll() {
            this.completedDocsWidgetExpanded = false
            this.incompleteDocsWidgetExpanded = false
            this.canceledDocsWidgetExpanded = false
        },
        onUpdate() {
            this.$emit('updated')
        },
        openDocumentUploadModal() {
            this.documentUploadModalOpen = true
        },
        openAddDocumentModal() {
            this.addDocumentModalOpen = true
        },
        openCompleteDocTaskModal(docTask) {
            this.docTaskToComplete = docTask
        },
        makeHRCustomFormPhotoUrl(customForm, photoId) {
            if (customForm.employee_id) {
                return `${this.$api.API_BASE}/clients/${this.client.id}/employees/${customForm.employee_id}/hr-custom-forms/${customForm.id}/photos/${photoId}`
            } else if (customForm.onboarding_application_id) {
                return `${this.$api.API_BASE}/clients/${this.client.id}/onboarding-applications/${customForm.onboarding_application_id}/hr-custom-forms/${customForm.id}/photos/${photoId}`
            }
            return ''
        },
    },
}
</script>

<style scoped lang="scss">
    @import "@/assets/scss/globals";
    .active-item {
        background-color: #DCEEF6;
    }
    // Tiny thumbnail image of document
    .docphoto-thumb {
        background-color: gray("150");
        // background-image set inline above
        background-position: center;
        background-size: cover;
        border: solid 1px $border-color;
        border-radius: 3px;
        height: 24px;
        width: 24px;
        line-height: 23px; // 24px results in slightly off-center text
        text-align: center;
    }
</style>
